import { Tradable } from "@models/interfaces/tradable";
import { Candle, Fiat } from "@models";
import { Point } from "@models/point";
import { Timespan } from "@helpers/const/timespan";
import { TimePeriod, MarginLimitOrder } from "../../../../api/graphql/bff/generated/types.graphql-gen";

export enum ChartLineColor {
	Green = "var(--color-positive-stroke-primary)",
	Red = "var(--color-negative-fill-primary)",
	Gray = "var(--color-neutrals-fill-secondary)",
	GreenLegacy = "#33d778",
	Black = "var(--color-neutrals-fill-primary)"
}

export interface LineChartConfig {
	tradable: Tradable;
	timespan: Timespan | TimePeriod;
	fiat: Fiat;
	language: string;
	data: Point[];
	lastTradingDayStart?: string;
	lastTradingDayEnd?: string;
	isSmall?: boolean;
	lineWidth?: number;
	lineColor?: ChartLineColor;
	liquidationPrice?: LiquidationPrice;
	limitOrders?: MarginLimitOrder[];
}

interface LiquidationPrice {
	precision: number;
	unit_symbol: string;
	unit_symbol_type: string;
	value: string;
}

export interface LineChartSmallConfig {
	isIntraday: boolean;
	data: Point[];
	lastTradingDayStart?: string;
	lastTradingDayEnd?: string;
	lineWidth?: number;
}

export interface AdvancedChartConfig {
	tradable: Tradable;
	timespan: Timespan;
	fiat: Fiat;
	language: string;
	data: Candle[];
	lastTradingDayStart?: string;
	lastTradingDayEnd?: string;
	isSmall?: boolean;
}

export interface ColumnChartConfig {
	data: number[];
	categories: string[];
}
